module.exports = __webpack_public_path__ + "img/Stone Table Not Level.53f69c8a.png";